<template>
    <component
        :is="formElementComponent"
        :id="id"
        :form-element-component="selfComponent"
        :custom-component-input="customComponentInput"
        :form="form"
        :touched="touched"
        :value="modelValue"
        :depth="depth"
        :required="required"
        :disabled="disabled"
        :strings="strings"
        :deletable="deletable"
        :description="description"
        :rbac-disabled="rbacDisabled"
        :wrap-value-mode="wrapValueMode"
        :custom-title="customTitle"
        :show-validation-errors="showValidationErrors"
        v-bind="$attrs"
        @input="$emit('update:modelValue', $event)"
    >
        <template #icon>
            <slot name="icon" />
        </template>
        <template #deleteIcon>
            <slot name="deleteIcon" />
        </template>
    </component>
</template>

<script lang="ts">
    import { markRaw, type Component as VueComponent } from 'vue';

    import { Component, Prop, Vue } from 'vue-property-decorator';

    import JsonForm from '@evidentid/json-schema/interfaces/JsonForm';

    import AbstractJsonSchemaFormElement from './AbstractJsonSchemaFormElement';

    @Component({
        inheritAttrs: false,
        name: 'JsonSchemaFormElement',
        emits: [ 'update:modelValue' ],
    })
    export default class JsonSchemaFormElement extends AbstractJsonSchemaFormElement {
        // markRaw: a class field becomes reactive data, and wrapping a component
        // definition in a proxy makes Vue warn about the needless overhead every time
        // it resolves this `<component :is>`.
        private selfComponent = markRaw(JsonSchemaFormElement);

        @Prop(Object)
        private form!: JsonForm;

        @Prop()
        private modelValue!: any;

        @Prop({ type: Boolean, default: false })
        private deletable!: boolean;

        @Prop(String)
        private id!: string;

        @Prop({ type: String, default: '' })
        private description!: string;

        @Prop({ type: Number, default: null })
        private depth!: number | null;

        private get formElementComponent(): VueComponent {
            return this.getCustomComponent?.(this.form, this.components) || this.components[this.form.type];
        }
    }
</script>
